import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_PARENT_ADD, MANAGE_PARENT_DELETE, MANAGE_PARENT_EDIT, MANAGE_PARENT_VIEW, MANAGE_PARENTS_LIST } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const parentsAPi = createApi({

    reducerPath: 'parentsAPi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/guardian/parent",
    }),
    tagTypes: ["ParentsList", "ParentDetails"],
    endpoints: (builder) => ({

        // get parents list
        getParentsList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_PARENTS_LIST,
                data: { search, status, page, limit, sort, },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ParentsList"]
        }),

        // get goal data
        getParentDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_PARENT_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ParentDetails"]
        }),

        // create parent
        createParent: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_PARENT_ADD,
                data
            }),
            invalidatesTags: ["ParentsList"]
        }),

        // update parent
        updateParent: builder.mutation({
            query: ({ data, parentId }) => ({
                method: "PUT",
                url: `${MANAGE_PARENT_EDIT}/${parentId}`,
                data
            }),
            invalidatesTags: ["ParentsList", "ParentDetails"]
        }),

        // delete parent
        deleteParent: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_PARENT_DELETE}/${id}`
            }),
            invalidatesTags: ["ParentsList", "ParentDetails"]
        })
    }),
})

export const {

    useGetParentsListQuery,
    useCreateParentMutation,
    useDeleteParentMutation,
    useGetParentDetailQuery,
    useUpdateParentMutation

} = parentsAPi;